var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "mail",
  "use": "mail-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"mail\">\n    <path d=\"M0 0h24v24H0V0z\" fill=\"none\" />\n    <path d=\"M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol